<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <div
        class="timeline__item d-flex flex-column justify-content-center align-items-center pointer-on-hover"
        :class="status"
        v-bind="attrs"
        @click="$emit('click')"
        v-on="on"
      >
        <div
          :data-icon="icon"
          class="timeline__icon d-flex justify-content-center align-items-center rounded-circle mb-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg">
            <use :xlink:href="icon" />
          </svg>
        </div>
        <p class="timeline__text mb-0">
          <slot>
            {{ cycle.cycle_name }}
          </slot>
        </p>
      </div>
    </template>
    <slot name="tooltip">
      <span>{{ cycle.begin_formatted }} - {{ cycle.end_formatted }}</span>
    </slot>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    cycle:{
      required: true,
      type: Object,
    },
  },

  computed: {
    ...mapGetters(['selectedCycle','authUser']),
    icon() {

      if (this.cycle.disabled) {
        return '#icon-lock'
      }

      if (this.cycle.is_finished) {
        return '#icon-finished'
      }

      if (this.cycle.is_current) {
        return '#icon-current'
      }

      return '#icon-planet'
    },
    status() {
      if(this.authUser.is_manager || this.authUser.is_teacher){
        return this.selectedCycle?.id === this.cycle.id ? 'selected' : 'normal'
      }
      return this.cycle.disabled ? 'lock' : this.selectedCycle?.id === this.cycle.id ? 'selected' : 'normal'
    }
  },
}
</script>
